/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNSAxMS41aDFWMUgzLjV2MUgxNXY5LjVaTTEgMTRWM2gxM3YxMUgxWk0yIDR2OWgxMVY0SDJabTQuNSAzLjVhMSAxIDAgMSAxLTIgMCAxIDEgMCAwIDEgMiAwWm0uNDE0IDIuNTg2QTIgMiAwIDAgMCAzLjUgMTEuNWg0YTIgMiAwIDAgMC0uNTg2LTEuNDE0Wk0xMiA3LjVIOC41djFIMTJ2LTFabS0yLjg3IDNoMi44OHYxSDkuMTN2LTFaIiBmaWxsPSJpbmhlcml0Ii8+";